module.exports = __webpack_public_path__ + "./img/strand_icon_geometry_position_direction.svg";